import { apiClient } from '../api/fetchClient';

export class ErrorService {
  async error(messages: string[]): Promise<string> {
    return await apiClient.post('/apps/single/v3/error', {
      messages,
    });
  }
}
